<template id="page-top">
  <div class="row" v-if="alert_sandbox">
    <div class="col-lg-12 col-sm-12 col-xs-12 mb-n3">
       <div class="alert alert-warning">
        <strong>Nota:</strong> Este ambiente é <strong>Sandbox</strong>, ou seja, tem como finalidade testar a ferramenta. Não é aconselhável informar dados reais, pois estes serão removidos após um período.
    </div>
    </div>
  </div>
  <notifications position="top center" />
  <vue3-confirm-dialog></vue3-confirm-dialog>
  <div id="wrapper">
    <menuLeft v-if="!$route.meta.hideMenu"></menuLeft>
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <menuTop v-if="!$route.meta.hideMenu"></menuTop>
        <router-view />
      </div>
      <descriptionFooter></descriptionFooter>
    </div>
  </div>
</template>

<script>
import menuLeft from './components/menu/menu-left.vue'
import menuTop from '@/components/menu/menu-top.vue'
import descriptionFooter from '@/components/footer/description-footer.vue'

export default {
  name: 'App',
  components: { menuLeft, menuTop, descriptionFooter },
  data(){
    return {
      alert_sandbox:false
    }
  },

  mounted(){
  
    const alert = (process.env.VUE_APP_ENVIRONMENT_ALERT);
    if(alert == 'sandbox'){
      this.alert_sandbox = true;
    }  

  }
}
</script>

<style></style>
